import classNames from "classnames"
import * as styles from "./VimeoPlayButton.module.scss"

export const VimeoPlayButton = (props: React.SVGProps<SVGSVGElement> = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 20"
    fill="none"
    {...props}
    className={classNames(styles?.playBtn, props?.className)}
  >
    <path
      d="M1.55743 0.86337C0.891563 0.442821 0.0234375 0.921303 0.0234375 1.70886V18.2907C0.0234375 19.0783 0.891562 19.5568 1.55743 19.1362L14.6847 10.8453C15.3061 10.4529 15.3061 9.54673 14.6847 9.15431L1.55743 0.86337Z"
      fill="white"
    />
  </svg>
)
